import React, { useCallback } from 'react';
import { Tags } from 'opentracing';
import { setFlowId, trace } from '@pegasus/observability/client';
import { ErrorBoundary as PErrorBoundary } from '@pegasus/error-boundary';
import { trackErrorContent } from '@browsing/tracking';
export var ErrorBoundary = function (_a) {
    var children = _a.children, componentName = _a.componentName, fallbackUI = _a.fallbackUI;
    var onError = useCallback(function (error) {
        var _a;
        var message = error.message, stack = error.stack, name = error.name;
        trackErrorContent({
            errorType: 'render_error',
            errorSeverity: 'high',
            info: componentName,
        });
        var span = trace.startSpan('render_client_error', {
            attributes: (_a = {},
                _a[Tags.ERROR] = true,
                _a.componentName = componentName,
                _a),
        });
        setFlowId(span);
        span.setAttribute('error.name', name);
        span.setAttribute('error.message', message);
        span.addEvent('error', { message: message, stack: stack, name: name });
        span.end();
    }, [componentName]);
    return (React.createElement(PErrorBoundary, { componentName: componentName, fallbackUI: fallbackUI, onDidCatch: onError }, children));
};
